export default __webpack_public_path__ + "static/media/Facebook.2c76e051.png";